module.exports = __webpack_public_path__ + "static/media/additionalretreat.4415d930.jpg";